module.exports = __webpack_public_path__ + "img/trans.152feac3.png";